import { z } from 'zod'

export const sludgeOilBilgeSchema = z.object({
  // TODO: add sludge & oil bilge fields
})
